import { Typography } from '@material-ui/core'
import EditUserIcon from '@material-ui/icons/Edit'
import AddUserIcon from '@material-ui/icons/PersonAdd'

import { getTranslate } from '../../localization'
import useStyles from './styles/userFormHeader.styles'

interface UserHeaderProps {
  params: {
    id: string
  }
}

const UserHeader: React.FC<UserHeaderProps> = ({ params }) => {
  const classes = useStyles()

  return (
    <div className={classes.header}>
      {params.id ? (
        <EditUserIcon fontSize="large" />
      ) : (
        <AddUserIcon fontSize="large" />
      )}
      <Typography className={classes.title} variant="h3" gutterBottom>
        {getTranslate(params.id ? 'Edit User' : 'Add New User')}
      </Typography>
    </div>
  )
}
export default UserHeader
